export default __webpack_public_path__ + "static/media/IntegrationWhatsapp.93141aba.jpg";